import React from 'react';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import Techs from '../components/SupportedTechnologies/techs';


function APMPage() {
  const { id } = useParams();
  const posts = {
    "russian": Techs,
    "international": Techs
  }
  
  // if (!posts[id]) {
  //   return <NotFound />
  // }

  return (
    <div className='w-full bg-white overflow-hidden'>
        <div className='container mx-auto px-4 py-8 '>
            <Techs />
      </div>
    </div>
  );
}

export default APMPage; 